import { render } from "./SimpleDictView.vue?vue&type=template&id=60d252a8&scoped=true"
import script from "./SimpleDictView.vue?vue&type=script&lang=js"
export * from "./SimpleDictView.vue?vue&type=script&lang=js"

import "./SimpleDictView.vue?vue&type=style&index=0&id=60d252a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d252a8"]])

export default __exports__